module.exports = __webpack_public_path__ + "static/1st-tpm-4-f5d8c7c279087e6edd5ae644312712b7.jpg";